import React from "react";
import { Link } from "gatsby";
import type { ArticleProps } from "@src/components/sections/NewLatestArticles/NewLatestArticles";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { useLiveUpdates } from "@hooks/useLiveUpdates";
import { getContentfulPreviewPropsFn } from "@utils";
import clsx from "clsx";

type CardArticleProps = {
  article: ArticleProps;
  childClassName?: string;
  theme?: string;
};

const NewCardArticle = ({
  article: rawArticle,
  childClassName = "",
  theme,
}: CardArticleProps): JSX.Element => {
  const article = useLiveUpdates(rawArticle);
  
  const articlePreviewProps = getContentfulPreviewPropsFn(
    rawArticle.contentful_id
  );
  const { title, slug, heroImage, type = "", description } = article;
  const image = getImage(heroImage?.gatsbyImageData);
  return (
    <article className={childClassName} {...articlePreviewProps("title")}>
      <section className="flex flex-col justify-between h-full">
        <div className="flex flex-col gap-4">
          <div
            className="rounded-lg overflow-hidden"
            {...articlePreviewProps("heroImage")}
          >
            {image && <GatsbyImage alt={heroImage.title} image={image} />}
          </div>
          <div>
            <h4
              className="text-18px font-bold mb-2 plain"
              {...articlePreviewProps("title")}
            >
              {title}
            </h4>
            <p
              className="text-rt-s mb-4"
              {...articlePreviewProps("description")}
            >
              {description?.description ?? description}
            </p>
          </div>
        </div>

        {slug && (
          <Link
            to={`/${type.toLowerCase()}/${slug}/`}
            className={clsx(
              "flex gap-2 items-center group  hover:underline",
            )}
          >
            Explore
            <svg
              className="transition-all group-hover:ml-1"
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.68903 3.35641C8.8973 3.14812 9.23499 3.14812 9.44327 3.35641L13.71 7.62308C13.9182 7.83136 13.9182 8.16904 13.71 8.37732L9.44327 12.644C9.23499 12.8523 8.8973 12.8523 8.68903 12.644C8.48074 12.4357 8.48074 12.098 8.68903 11.8897L12.0452 8.53353H2.66615C2.3716 8.53353 2.13281 8.29475 2.13281 8.0002C2.13281 7.70565 2.3716 7.46686 2.66615 7.46686H12.0452L8.68903 4.11065C8.48074 3.90237 8.48074 3.56469 8.68903 3.35641Z"
                fill="currentColor"
              />
            </svg>
          </Link>
        )}
      </section>
    </article>
  );
};

export default NewCardArticle;
